import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { SkeletonTheme } from "react-loading-skeleton";
import reportWebVitals from "./reportWebVitals";
// import { PersistGate } from "redux-persist/integration/react";

import { Provider } from "react-redux";
import App from "./App";
import GlobalStyle from "./globals/style";
import theme from "./globals/theme";
import "./index.css";
import "./kmmrce-theme.css";
// Loaded last so the Felix brand layer wins over the legacy theme.
import "./globals/felix-overrides.css";
import store from "./redux/store";

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      {/* react-loading-skeleton defaults to a light grey shimmer, which on the
          dark shell read as bright flashing blocks. Match the surfaces. */}
      <SkeletonTheme
        baseColor={theme.colors.surfaceRaised}
        highlightColor={theme.colors.surfaceHover}
        borderRadius={theme.radii.sm}
        duration={1.2}
      >
      <Provider store={store}>
        {/* <PersistGate loading={null} persistor={persistor}> */}
        <Router>
          <App />
        </Router>
        {/* </PersistGate> */}
      </Provider>
      </SkeletonTheme>
      <GlobalStyle />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
